module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm_title1",
    attrs: {
      "id": "gloss"
    }
  }, [_vm._v("GLOSSARY")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_1",
      "id": "rgloss_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AAR")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("After-Action Report")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Abwehr")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("German Military Intelligence Service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#gloss_3",
      "id": "rgloss_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ACP")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Automatic Colt Pistol")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_4",
      "id": "rgloss_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AFHQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Allied Force Headquarters")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_5",
      "id": "rgloss_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("agent")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("a recruited field operative directed by an intelligence service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_6",
      "id": "rgloss_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Andartes")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Greek resistance fighters ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Andartis")]), _vm._v(" = singular)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#gloss_7",
      "id": "rgloss_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Auxiliary")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("the support wing of a resistance or partisan movement")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_8",
      "id": "rgloss_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BCRA")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bureau Central de Renseignements et d’Action")]), _vm._v(" (established 17 January 1942)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_9",
      "id": "rgloss_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BOA")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bureau des Opérations Aériennes")]), _vm._v(" – BCRA circuits to set up aerial resupply drops")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_10",
      "id": "rgloss_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BSC")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("British Security Coordination, New York")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_11"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("C")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Chief of SIS, code name after Captain Sir Mansfield Smith-Cumming")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_12",
      "id": "rgloss_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CBI")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("China-Burma-India")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_13"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CD")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Director of SOE")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#gloss_14",
      "id": "rgloss_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CIA")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Central Intelligence Agency")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#gloss_15",
      "id": "rgloss_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CIG")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Central Intelligence Group, forerunner of the CIA")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#gloss_16",
      "id": "rgloss_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Circuit")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("SOE/OSS name for a team attached to an underground network")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_17"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CO")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Commanding Officer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_18",
      "id": "rgloss_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("COI")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Coordinator of Information")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_19"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CoS")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Chiefs of Staff")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#gloss_20",
      "id": "rgloss_20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CQB")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Close Quarter Battle")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_21"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("D")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("‘Destruction’, SIS Section for sabotage")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#gloss_22",
      "id": "rgloss_22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DF")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("direction finding")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_23"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DMI")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Director of Military Intelligence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_24"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DMO")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Director of Military Operations")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_25"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DNI")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Director of Naval Intelligence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_26"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DoD")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Department of Defense")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_27",
      "id": "rgloss_27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DoS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Department of State")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_28",
      "id": "rgloss_28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DSC")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Distinguished Service Cross")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#gloss_29",
      "id": "rgloss_29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DSO")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Distinguished Service Order")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_30"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DSS")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Director of Strategic Services – William Donovan")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#gloss_31",
      "id": "rgloss_31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("drop zone")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_32",
      "id": "rgloss_32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EAM")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("National Liberation Front – Greek communist resistance")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_33",
      "id": "rgloss_33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EDES")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("National Democratic Greek League – republican resistance")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_34",
      "id": "rgloss_34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EH")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Electra House, Foreign Office affiliated propaganda section")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_35",
      "id": "rgloss_35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ELAS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("military wing of communist EAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_36"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EM")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("enlisted men")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_37",
      "id": "rgloss_37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EMFFI")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("État-major des Forces Françaises de l’Intérieur")]), _vm._v(" (French Forces of the Interior)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_38",
      "id": "rgloss_38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EOEA")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("National Groups of Greek Guerrillas, military wing of EDES")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_39"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ETO")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("European Theatre of Operations")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_40"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FANY")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("First Aid Nursing Yeomanry")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_41",
      "id": "rgloss_41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FBI")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Federal Bureau of Investigation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_42",
      "id": "rgloss_42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FDR")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Franklin Delano Roosevelt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_43",
      "id": "rgloss_43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FFI")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Forces Françaises de l’Intérior")]), _vm._v(" (French republican resistance organisation)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_44"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FN")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Front National")]), _vm._v(" (French communist resistance movement)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_45",
      "id": "rgloss_45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FO")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Foreign Office")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#gloss_46",
      "id": "rgloss_46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("F-S")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Fairbairn-Sykes")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_47",
      "id": "rgloss_47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FTP")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Francs-Tireurs et Partisans")]), _vm._v(" (French communist resistance force)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/03_Dedication#gloss_48",
      "id": "rgloss_48"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GC")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("George Cross")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#gloss_49",
      "id": "rgloss_49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gestapo")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Geheime Staatspolizei")]), _vm._v(" – Secret State Police")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_50",
      "id": "rgloss_50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GS(R)")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("General Staff (Research): the first name for MI(R), see below")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_51",
      "id": "rgloss_51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Guerrilla")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("member of a small independent group taking part in irregular fighting")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_52",
      "id": "rgloss_52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HE")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("High Explosives")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_53",
      "id": "rgloss_53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Headquarters")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_54"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ISRB")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Inter Services Research Bureau (cover name of SOE)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_55",
      "id": "rgloss_55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("JCS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Joint Chiefs of Staff")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#gloss_56",
      "id": "rgloss_56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("JEDBURGH")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Multi-national, three-man SO teams, usually American, British and French soldiers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_57"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LRDG")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Long Range Desert Group")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#gloss_58",
      "id": "rgloss_58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("landing zone")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_59",
      "id": "rgloss_59",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maquis")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("nickname for French rural Partisans")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_60",
      "id": "rgloss_60",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maquisard")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("A member of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maquis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#gloss_61",
      "id": "rgloss_61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MC")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Military Cross")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#gloss_62",
      "id": "rgloss_62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MD1")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Military research and development section, formerly MIR(c), aka ‘Churchill’s Toyshop’")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_63",
      "id": "rgloss_63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MEW")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Ministry of Economic Warfare")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_64",
      "id": "rgloss_64",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MID")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Military Intelligence Directorate (G-2)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_65",
      "id": "rgloss_65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MILORG")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Norwegian Resistance Group")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_66",
      "id": "rgloss_66",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI(R)")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Military Intelligence (Research), initially GS(R), set up to study irregular warfare")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#gloss_67",
      "id": "rgloss_67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MIR(c)")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("MI(R)’s research and development office, later MD1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_68"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI5")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Military Intelligence Department 5 – internal security and counter-intelligence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Timeline#gloss_69",
      "id": "rgloss_69"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI6")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("External Intelligence – see SIS")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_70"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI9")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Military Intelligence Department Section 9 – Escape & Evasion Networks")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_71",
      "id": "rgloss_71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MO")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Morale Operations Branch")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_72"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MO1(SP)")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Cover name for SOE")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#gloss_73",
      "id": "rgloss_73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MoD")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_74",
      "id": "rgloss_74",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MTB")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Motor Torpedo Boat")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_75"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MTO")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Mediterranean Theatre of Operations")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_76",
      "id": "rgloss_76",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MU")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Maritime Unit")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_77",
      "id": "rgloss_77",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("NATO")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("North African Theatre of Operations, later MTO")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#gloss_78",
      "id": "rgloss_78",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("NKVD")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("People’s Commissariat for Internal Affairs, forerunner of the KGB")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_79",
      "id": "rgloss_79",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("NCO")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("non-commissioned officer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_80"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("OCI")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Office of the Coordinator of Information")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_81"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("OC")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Officer Commanding")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_82",
      "id": "rgloss_82",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("OG")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Operational Groups")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_83",
      "id": "rgloss_83",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ONI")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Office of Naval Intelligence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_84",
      "id": "rgloss_84",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Operative")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("fully trained individual employed by SOE or OSS, sometimes called an agent")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_85"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("OR")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("other ranks")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Introduction#gloss_86",
      "id": "rgloss_86"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("OSS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Office of Strategic Services")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_87"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("OWI")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Office of War Information – official ‘white’ propaganda service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_88",
      "id": "rgloss_88",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Partisan")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("member of armed group to fight secretly against an occupying force")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_89",
      "id": "rgloss_89",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pétainist")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("collaborator")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_90"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PID")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Foreign Office Political Intelligence Department")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#gloss_91",
      "id": "rgloss_91",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PM")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Prime Minister")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_92",
      "id": "rgloss_92",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("POW")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("prisoner of war")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_93",
      "id": "rgloss_93",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PWE")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Political Warfare Executive")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#gloss_94",
      "id": "rgloss_94",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("R&D")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Research and Development")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_95",
      "id": "rgloss_95",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RAF")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Royal Air Force")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_96"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RDX")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Research Department Explosive")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_97",
      "id": "rgloss_97",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RE")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Royal Engineer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_98"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RTU")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("returned to unit")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#gloss_99",
      "id": "rgloss_99",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SAB")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Students’ Assessment Board")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#gloss_100",
      "id": "rgloss_100",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SAS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Special Air Service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#gloss_101",
      "id": "rgloss_101",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SBS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Special Boat Section")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_102"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SD")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sicherheitsdienst")]), _vm._v(" – the intelligence service of the SS")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#gloss_103",
      "id": "rgloss_103",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Section D")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("SIS section ‘Destruction’, formed for sabotage operations")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_104",
      "id": "rgloss_104",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SF")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Special Forces"), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Glossary#st1",
      "id": "rst1"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_105",
      "id": "rgloss_105",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SFHQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Special Force Headquarters, coordinating office at SHAEF, replaced SOE/SO")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_106",
      "id": "rgloss_106",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SHAEF")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Supreme Headquarters Allied Expeditionary Forces")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#gloss_107",
      "id": "rgloss_107",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Singleton")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("operative or agent working alone")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Introduction#gloss_108",
      "id": "rgloss_108"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Secret Intelligence Service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#gloss_109",
      "id": "rgloss_109",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SMG")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("sub-machine gun")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_110",
      "id": "rgloss_110",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SO")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Special Operations")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_111",
      "id": "rgloss_111",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SO1")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("SOE propaganda section")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_112",
      "id": "rgloss_112",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SO2")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("SOE active operations section")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_113",
      "id": "rgloss_113",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SO3")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("SOE research section")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Introduction#gloss_114",
      "id": "rgloss_114"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SOE")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Special Operations Executive")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_115",
      "id": "rgloss_115",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SOE/SO")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Allied special forces coordinating office at SHAEF, later SFHQ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_116",
      "id": "rgloss_116",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SOM")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Special Operations Mediterranean, coordinating office at AFHQ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_117",
      "id": "rgloss_117",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Schutzstaffel")]), _vm._v(" – the armed corps of the Nazi party")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_118",
      "id": "rgloss_118",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SSU")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Strategic Services Unit")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#gloss_119",
      "id": "rgloss_119",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Special Training School")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_120"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("S&T")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Schools and Training branch")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#gloss_121",
      "id": "rgloss_121",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Underground")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("group or movement organised secretly to fight an existing regime or occupying power")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_122",
      "id": "rgloss_122",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WO")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("War Office")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_123",
      "id": "rgloss_123",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("W/T")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Wireless Telegraphy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#gloss_124",
      "id": "rgloss_124",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("X-2")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("OSS Counter-intelligence branch")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Glossary#rst1",
      "id": "st1"
    }
  }, [_vm._v("*")]), _vm._v(" Special Forces is capitalised in the US to designate a specific US Army unit, while the general term ‘special forces’ as used in the UK is usually written in lower case.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-437ef556","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Glossary.vue
// module id = 78
// module chunks = 0